import React, { useState, useEffect } from 'react';
import { useScan } from '../context/InventoryContext'; // Adjust path if needed
import { BASE_URL } from '../const'; // Adjust path if needed

const ScannedProductPopup = ({ code, onSubmit, onClose }) => {
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(false);
  const { addItem } = useScan();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");

        const response = await fetch(`${BASE_URL}/sku/${code}`, {
          method: 'GET',
          headers: {
            Authorization: `Token ${token}`,
          },
        });

        if (!response.ok) throw new Error('SKU not found');

        const data = await response.json();
        setProduct(data);
      } catch (err) {
        console.error('Fetch error:', err);
        setProduct(null);
      } finally {
        setLoading(false);
      }
    };

    if (code) fetchProduct();
  }, [code]);

  if (!code) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button onClick={onClose} style={styles.close}>×</button>

        {loading ? (
          <p>Loading product...</p>
        ) : product === null ? (
          <p>No product found for <strong>{code}</strong></p>
        ) : (
          <>
            <img src={product.image_link} alt={product.product_name} style={styles.image} />
            <p><strong>SKU:</strong> {product.sku}</p>
            <p><strong>EAN:</strong> {product.ean}</p>
            <p><strong>Name:</strong> {product.product_name}</p>
            <p><strong>MRP:</strong> ₹{product.max_mrp}</p>
            <div>
              <label>Qty:</label>
              <input
                type="number"
                min="1"
                value={qty}
                onChange={(e) => setQty(Number(e.target.value))}
                style={styles.input}
              />
            </div>
            <button
              style={styles.submit}
              disabled={qty < 1}
              onClick={() => {
                const newItem = { ...product, qty };
                addItem(newItem);
                if (onSubmit) onSubmit(newItem);
                onClose();
              }}
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  popup: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    width: 320,
    maxWidth: '90%',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    position: 'relative'
  },
  close: {
    position: 'absolute',
    top: -2,
    right: 10,
    width: 30,
    height: 30,
    backgroundColor: '#ff4d4f',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: '13px',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
  },
  image: {
    maxWidth: '50%',
    maxHeight: '50%',
    objectFit: 'contain'
  },
  input: {
    width: '100%',
    padding: 8,
    marginTop: 5,
    marginBottom: 10
  },
  submit: {
    width: '100%',
    padding: 10,
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer'
  }
};

export default ScannedProductPopup;
